import React, { Fragment, useState } from 'react';
import { Typography, Button, Form, message, Input, DatePicker } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Dropzone from 'react-dropzone';
import Axios from 'axios';
import config from '../../Config/key';
import Papa from 'papaparse';
import {
  decodeCsvBuffer,
  validateCsvHeaders,
  formatHeaderValidationError,
  extractAxiosErrorMessage,
} from '../../../utils/csvUploadHelper';
import locale from 'antd/es/locale/ja_JP';
import dayjs from 'dayjs';
const { TextArea } = Input;
const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

// CSV に必要な必須列
// - name, lastname     : 受講者氏名（必須）
// - Q001_answer, Q080_answer : 80問の回答グループの先頭/末尾。
//   この2つが揃っていれば答案グループ全体が含まれていると推定する。
//   中間欠落（例: Q040_answer のみ無し）は本検証では捕捉しないが、
//   メッセージの簡潔さを優先する設計判断（運用合意済み）。
const REQUIRED_COLUMNS = ['name', 'lastname', 'Q001_answer', 'Q080_answer'];
//yyyy-mm-dd 00:00:00
const today_ymd = () => {
  let date = new Date();
  return (
    date.getFullYear() +
    '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + date.getDate()).slice(-2) +
    ' 00:00:00'
  );
};
function CSVUploadPage(props) {
  const [value, setValue] = useState({
    survey_start_date: today_ymd(),
    survey_end_date: today_ymd(),
  });
  const [fileData, setFileData] = useState();
  const [fileJSON, setFileJSON] = useState();
  const [projectDescriptionValue, setProjectDescriptionValue] = useState('');
  const [projectKeyValue, setProjectKeyValue] = useState();

  const onDrop = (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading failed');
    reader.onload = (e) => {
      //ファイルの読み込みが終わったら発火
      // decodeCsvBuffer で文字コード自動判定 + 先頭 BOM 除去まで一括処理
      const unicodeString = decodeCsvBuffer(e.target.result);
      Papa.parse(unicodeString, {
        header: true,
        dynamicTyping: false,
        skipEmptyLines: true,
        complete: async (results) => {
          // 必須列の存在検証（BOM は decodeCsvBuffer で除去済み、その他不可視文字を捕捉）
          const headers = (results.meta && results.meta.fields) || [];
          const v = validateCsvHeaders(headers, REQUIRED_COLUMNS);
          if (!v.ok) {
            message.error({
              content: formatHeaderValidationError(v),
              key: 'csvupload',
              duration: 10,
            });
            setFileJSON(undefined);
            setFileData(
              'エラー：CSVヘッダーを確認の上、再アップロードしてください。'
            );
            return;
          }
          setFileData(unicodeString);
          setFileJSON(results.data);
          // const courseInfo = courseMerge(results.data);
          setProjectKeyValue(`${ymdhms()}`);
          // console.log({ courseInfo });
        },
      });
    };
    reader.readAsArrayBuffer(file); //ファイルを読み込む
  };

  //yyyymmddhhmmss
  const ymdhms = () => {
    var date = new Date();
    return (
      date.getFullYear() +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      ('0' + date.getDate()).slice(-2) +
      ('0' + date.getHours()).slice(-2) +
      ('0' + date.getMinutes()).slice(-2) +
      ('0' + date.getSeconds()).slice(-2)
      // date.getMilliseconds()
    );
  };

  // const courseMerge = (fileJSON) => {
  //   let courseInfos = []; //単純分類用
  //   fileJSON.map((record) => {
  //     // courseを分離して配列を作る
  //     courseInfos.push({
  //       course_id: record.course_id,
  //       course_name: record.course_name,
  //       lesson_id: record.lesson_id,
  //       lesson_name: record.lesson_name,
  //       chapter_id: record.chapter_id,
  //       chapter_name: record.chapter_name,
  //     });
  //   });

  //   //course_idを基準に重複をなくす
  //   const courseInfo = [
  //     ...new Map(courseInfos.map((info) => [info.course_id, info])).values(),
  //   ];

  //   //上位の１個だけをReturn
  //   return courseInfo[0];
  // };
  //研修日程をStart→Endの形に変更 20221215
  const onChangeSurveyPriod = (date, dateString) => {
    // console.log(date, dateString);
    setValue({
      ...value,
      survey_start_date: dateString[0] + ' 00:00:00',
      survey_end_date: dateString[1] + ' 23:59:59',
    });
  };
  const onSubmit = async (event) => {
    event.preventDefault();
    let evaluationPower = []; //最終分類用
    try {
      // CSV が正常に読み込まれているかを確認（必須列検証で弾かれた場合は fileJSON が undefined）
      if (!fileJSON || !Array.isArray(fileJSON) || fileJSON.length === 0) {
        message.error({
          content:
            '有効なCSVファイルがアップロードされていません。CSVを再確認してください。',
          key: 'csvupload',
          duration: 3,
        });
        throw new Error('CSVデータがありません。');
      }

      const res = await Axios.post('/api/projectKey', {
        project_key: projectKeyValue,
        project_description: projectDescriptionValue,
        user_cnt: fileJSON.length,
        survey_start_date: value.survey_start_date,
        survey_end_date: value.survey_end_date,
      });
      // console.log({ res });

      if (res.data.success) {
        // console.log({ res });
        await fileJSON.map((record) => {
          evaluationPower.push({
            project_id: res.data.projectKey._id,
            // course_id: record.course_id,
            // course_name: record.course_name,
            // lesson_id: record.lesson_id,
            // lesson_name: record.lesson_name,
            // chapter_id: record.chapter_id,
            // chapter_name: record.chapter_name,
            // login_id: record.login_id,
            // タイポ修正: compamy → company（Mongoose strict で削られていた company が正常保存されるようになる）
            company: record.company,
            lastname: record.lastname,
            name: record.name,
            department: record.department,
            // study_session: record.study_session,
            // study_status: record.study_status,
            // study_start_date: record.study_start_date,
            study_end_date: record.study_end_date,
            answers: [
              record.Q001_answer === 'その通りである'
                ? 1
                : record.Q001_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q002_answer === 'その通りである'
                ? 1
                : record.Q002_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q003_answer === 'その通りである'
                ? 1
                : record.Q003_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q004_answer === 'その通りである'
                ? 1
                : record.Q004_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q005_answer === 'その通りである'
                ? 1
                : record.Q005_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q006_answer === 'その通りである'
                ? 1
                : record.Q006_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q007_answer === 'その通りである'
                ? 1
                : record.Q007_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q008_answer === 'その通りである'
                ? 1
                : record.Q008_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q009_answer === 'その通りである'
                ? 1
                : record.Q009_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q010_answer === 'その通りである'
                ? 1
                : record.Q010_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q011_answer === 'その通りである'
                ? 1
                : record.Q011_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q012_answer === 'その通りである'
                ? 1
                : record.Q012_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q013_answer === 'その通りである'
                ? 1
                : record.Q013_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q014_answer === 'その通りである'
                ? 1
                : record.Q014_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q015_answer === 'その通りである'
                ? 1
                : record.Q015_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q016_answer === 'その通りである'
                ? 1
                : record.Q016_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q017_answer === 'その通りである'
                ? 1
                : record.Q017_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q018_answer === 'その通りである'
                ? 1
                : record.Q018_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q019_answer === 'その通りである'
                ? 1
                : record.Q019_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q020_answer === 'その通りである'
                ? 1
                : record.Q020_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q021_answer === 'その通りである'
                ? 1
                : record.Q021_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q022_answer === 'その通りである'
                ? 1
                : record.Q022_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q023_answer === 'その通りである'
                ? 1
                : record.Q023_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q024_answer === 'その通りである'
                ? 1
                : record.Q024_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q025_answer === 'その通りである'
                ? 1
                : record.Q025_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q026_answer === 'その通りである'
                ? 1
                : record.Q026_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q027_answer === 'その通りである'
                ? 1
                : record.Q027_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q028_answer === 'その通りである'
                ? 1
                : record.Q028_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q029_answer === 'その通りである'
                ? 1
                : record.Q029_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q030_answer === 'その通りである'
                ? 1
                : record.Q030_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q031_answer === 'その通りである'
                ? 1
                : record.Q031_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q032_answer === 'その通りである'
                ? 1
                : record.Q032_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q033_answer === 'その通りである'
                ? 1
                : record.Q033_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q034_answer === 'その通りである'
                ? 1
                : record.Q034_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q035_answer === 'その通りである'
                ? 1
                : record.Q035_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q036_answer === 'その通りである'
                ? 1
                : record.Q036_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q037_answer === 'その通りである'
                ? 1
                : record.Q037_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q038_answer === 'その通りである'
                ? 1
                : record.Q038_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q039_answer === 'その通りである'
                ? 1
                : record.Q039_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q040_answer === 'その通りである'
                ? 1
                : record.Q040_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q041_answer === 'その通りである'
                ? 1
                : record.Q041_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q042_answer === 'その通りである'
                ? 1
                : record.Q042_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q043_answer === 'その通りである'
                ? 1
                : record.Q043_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q044_answer === 'その通りである'
                ? 1
                : record.Q044_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q045_answer === 'その通りである'
                ? 1
                : record.Q045_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q046_answer === 'その通りである'
                ? 1
                : record.Q046_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q047_answer === 'その通りである'
                ? 1
                : record.Q0047_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q048_answer === 'その通りである'
                ? 1
                : record.Q048_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q049_answer === 'その通りである'
                ? 1
                : record.Q049_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q050_answer === 'その通りである'
                ? 1
                : record.Q050_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q051_answer === 'その通りである'
                ? 1
                : record.Q051_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q052_answer === 'その通りである'
                ? 1
                : record.Q052_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q053_answer === 'その通りである'
                ? 1
                : record.Q053_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q054_answer === 'その通りである'
                ? 1
                : record.Q054_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q055_answer === 'その通りである'
                ? 1
                : record.Q055_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q056_answer === 'その通りである'
                ? 1
                : record.Q056_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q057_answer === 'その通りである'
                ? 1
                : record.Q057_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q058_answer === 'その通りである'
                ? 1
                : record.Q058_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q059_answer === 'その通りである'
                ? 1
                : record.Q059_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q060_answer === 'その通りである'
                ? 1
                : record.Q060_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q061_answer === 'その通りである'
                ? 1
                : record.Q061_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q062_answer === 'その通りである'
                ? 1
                : record.Q062_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q063_answer === 'その通りである'
                ? 1
                : record.Q063_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q064_answer === 'その通りである'
                ? 1
                : record.Q064_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q065_answer === 'その通りである'
                ? 1
                : record.Q065_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q066_answer === 'その通りである'
                ? 1
                : record.Q066_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q067_answer === 'その通りである'
                ? 1
                : record.Q067_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q068_answer === 'その通りである'
                ? 1
                : record.Q068_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q069_answer === 'その通りである'
                ? 1
                : record.Q069_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q070_answer === 'その通りである'
                ? 1
                : record.Q070_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q071_answer === 'その通りである'
                ? 1
                : record.Q071_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q072_answer === 'その通りである'
                ? 1
                : record.Q072_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q073_answer === 'その通りである'
                ? 1
                : record.Q073_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q074_answer === 'その通りである'
                ? 1
                : record.Q074_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q075_answer === 'その通りである'
                ? 1
                : record.Q075_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q076_answer === 'その通りである'
                ? 1
                : record.Q076_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q077_answer === 'その通りである'
                ? 1
                : record.Q077_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q078_answer === 'その通りである'
                ? 1
                : record.Q078_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q079_answer === 'その通りである'
                ? 1
                : record.Q079_answer === 'その通りでない'
                ? 2
                : 3,
              record.Q080_answer === 'その通りである'
                ? 1
                : record.Q080_answer === 'その通りでない'
                ? 2
                : 3,
            ],
          });
        });
        // console.log({ evaluationPower });
        const res3 = await Axios.post('/api/evaluationPower', evaluationPower);
        // console.log({ res3 });
        if (res3.data.success) {
          setFileData('CSVアップロードが完了しました。');
          message.success('CSVのアップロードが完了しました。');
          setTimeout(() => {
            props.history.push('/');
          }, 3000);
        }
      }
    } catch (error) {
      console.log({ error });
      /*
      ＜課題＞
      projectKeyがUniqueでない場合の処理を追加
      MongoDB error code 11000
      */
      // バックエンドの具体的なエラー本文を抽出して表示（運用担当が pm2 logs 参照不要）
      message.error({
        content: extractAxiosErrorMessage(
          error,
          'CSVアップロードに失敗しました。'
        ),
        key: 'csvupload',
        duration: 5,
      });
    }
  };

  const onChangeProjectKey = (e) => {
    setProjectKeyValue(e.currentTarget.value);
  };
  const onChangeProjectDescription = (e) => {
    setProjectDescriptionValue(e.currentTarget.value);
  };

  return (
    <Fragment>
      <div style={{ maxWidth: '700px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>回答情報登録</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* Drop zone */}
            <Dropzone onDrop={onDrop} multiple={false} maxSize={1000000000}>
              {({ getRootProps, getInputProps }) => (
                <div
                  style={{
                    width: '300px',
                    height: '240px',
                    border: '1px solid lightgray',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  <PlusOutlined style={{ fontSize: '3rem' }} />
                </div>
              )}
            </Dropzone>
            <div
              style={{
                width: '300px',
                height: '240px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Text mark>
                CSVファイルをDrag &
                Dropするか、+を押してファイルを選択してください。
              </Text>
            </div>
          </div>
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
            <Text strong>プロジェクトキーを入力してください（必須）</Text>
            <Input
              placeholder="一意になるプロジェクトキーを入力してください。"
              allowClear
              onChange={onChangeProjectKey}
              value={projectKeyValue}
            />
            <br />
            <br />
            <Text strong>プロジェクト説明を入力してください（任意）</Text>
            <Input
              placeholder="プロジェクトの説明を入力してください。"
              allowClear
              onChange={onChangeProjectDescription}
              value={projectDescriptionValue}
            />
          </div>
          <br />
          <br />
          <div>
            <Text strong>■ サーベイ回答日程</Text>
            <div
              style={{ display: 'flex', justifyContent: 'space-between' }}
            ></div>
          </div>
          <RangePicker
            onChange={onChangeSurveyPriod}
            locale={locale}
            value={[
              dayjs(value.survey_start_date),
              dayjs(value.survey_end_date),
            ]}
          />
          <br />
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
          <Button type="primary" size="large" onClick={onSubmit}>
            アップロード
          </Button>
        </Form>
        <TextArea rows={20} value={fileData} />
      </div>
    </Fragment>
  );
}

export default CSVUploadPage;
